(() => {
  const root = document.querySelector('[data-wh197-product-haunt]');
  if (!root || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Add subtle cursor-reactive parallax only on precise pointer devices.
  if (window.matchMedia('(pointer:fine)').matches) {
    const scene = root.querySelector('.wh197-haunt-scene');
    let raf = 0;
    window.addEventListener('pointermove', (event) => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const x = (event.clientX / window.innerWidth - .5) * 10;
        const y = (event.clientY / window.innerHeight - .5) * 7;
        scene?.style.setProperty('--wh197-parallax-x', `${x}px`);
        scene?.style.setProperty('--wh197-parallax-y', `${y}px`);
      });
    }, { passive: true });
  }

  // Make successful add-to-cart feel like part of the haunted scene without changing Shopify cart logic.
  document.addEventListener('cartUpdate', () => {
    root.classList.remove('wh197-cart-flash');
    void root.offsetWidth;
    root.classList.add('wh197-cart-flash');
    setTimeout(() => root.classList.remove('wh197-cart-flash'), 850);
  });
})();
